import { PublicLayout } from '../layout/PublicLayout';
import { useSEO } from '@/hooks/useSEO';
import { LEGAL_CONFIG, LEGAL_ROUTES } from './legalConfig';
import { accessibilityHtml } from './legalContent';

export const AccessibilityPage = () => {
  useSEO({
    title: `Accessibility Statement - ${LEGAL_CONFIG.companyName}`,
    description: `Accessibility Statement - ${LEGAL_CONFIG.companyName}`,
    keywords: 'accessibility',
    ogTitle: `Accessibility Statement - ${LEGAL_CONFIG.companyName}`,
    ogDescription: `Accessibility Statement - ${LEGAL_CONFIG.companyName}`,
    ogType: 'website',
    canonicalUrl: `https://${LEGAL_CONFIG.domain}${LEGAL_ROUTES.accessibility}`,
  });

  return (
    <PublicLayout>
      <article className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-16 md:py-24">
        <div
          className="prose prose-slate dark:prose-invert max-w-none space-y-8"
          dangerouslySetInnerHTML={{ __html: accessibilityHtml }}
        />
      </article>
    </PublicLayout>
  );
};
